export const getItemType = (type: string) => type.slice(0, -1) + "0";
